import { render, staticRenderFns } from "./ddpjs.vue?vue&type=template&id=2f9ab6aa"
import script from "./ddpjs.vue?vue&type=script&lang=js"
export * from "./ddpjs.vue?vue&type=script&lang=js"
import style0 from "./ddpjs.vue?vue&type=style&index=0&id=2f9ab6aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports